import { useEffect } from 'react';

import { useUserStore } from '../stores/userStore';

/**
 * Hook for natural feeling browsing behaviour when using multiple profiles
 * in multiple tabs or windows.
 */
export const useOriginatingProfile = (): void => {
  useEffect(() => {
    const visibilityChange = (): void => {
      if (document.visibilityState === 'hidden') {
        return;
      }

      const { getProfileToken, updateUser } = useUserStore.getState();

      // Update profile token with the value of the current window's profile.
      // When opening new tabs/windows, they will always use the originating
      // window's profile, enabling a natural feeling behaviour, even when
      // multiple profiles are used simultaneously.
      const profileToken = getProfileToken();

      if (profileToken) {
        updateUser(profileToken, false);
      }
    };

    window.addEventListener('visibilitychange', visibilityChange);

    return (): void => {
      window.removeEventListener('visibilitychange', visibilityChange);
    };
  }, []);
};
